// External imports
import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import './assets/index.scss';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Provider } from 'react-redux';
// Component imports
import Faq from './components/Faq';
import Contact from './components/Contact';
import Footer from './components/bars/Footer';
import ScrollHandler from './app/ScrollHandler';
import Login from './features/application/Login';
import AboutPurrser from './components/AboutPurrser';
import PrivacyPolicy from './components/PrivacyPolicy';
import TermsAndConditions from './components/TermsAndConditions';
import NotificationBar from './components/bars/NotificationBar';
// Helper functions
import { setupStore } from './store';
import * as serviceWorker from './serviceWorker';
import { ConnectContext, connector } from './api/connector';

// Spinner when downloading app. App will set it to hidden when loaded.
const spinner = document.getElementById('spinner');
if (spinner && !spinner.hasAttribute('hidden')) {
  spinner.setAttribute('hidden', 'true');
}

const store = setupStore();

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <ConnectContext.Provider value={connector}>
        <BrowserRouter>
          <ScrollHandler />
          <Routes>
            {/* Default here to decide if login screen is shown or app */}
            <Route path="/*" element={<Login />} />
            <Route path="terms" element={<TermsAndConditions />} />
            <Route path="privacy" element={<PrivacyPolicy />} />
            <Route path="contact" element={<Contact />} />
            <Route path="faq" element={<Faq />} />
            <Route path="about" element={<AboutPurrser />} />
          </Routes>
          {/* Footer and notification bar always shown no matter what */}
          <Footer />
          <NotificationBar />
        </BrowserRouter>
      </ConnectContext.Provider>
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);

serviceWorker.unregister();
